<template>
  <div class="record-com">
    <div class="search_condition flex-row justify-end">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="下注时间：">
          <el-date-picker
            @change="changeDate"
            v-model="formInline.time"
            class="dataTimer"
            type="daterange"
            size="medium"
            range-separator="-"
            prefix-icon="el-icon-date"
            popper-class="dateTimer-droper"
            :clearable="true"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <!--
        <el-form-item>
          <el-button @click="getListInfo" class="select-btn" plain>查询</el-button>
        </el-form-item>
				-->
      </el-form>
    </div>

    <el-table
      border
      :data="tableData"
      :row-style="{ height: '50px', fontSize: '14px' }"
      :cell-style="{ padding: 0 }"
      :header-row-style="tableHeaderRow"
      :header-cell-style="tableHeaderColor"
      v-loading="loading"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" type="index" width="80"> </el-table-column>
      <el-table-column label="直播标题" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.guess.live_title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="主播昵称/ID" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.anchor_name }}</span>
          <br />
          <span>({{ scope.row.anchor_id }})</span>
        </template>
      </el-table-column>
      <el-table-column label="问题/下注内容" align="center" width="120px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.guess.title }}</span>
          <br />
          <div>{{ scope.row.guessItemStr }}</div>
        </template>
      </el-table-column>
      <el-table-column label="下注鹰钻" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ Number(scope.row.amount / 100).toFixed(2) }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="oddsFormat" label="倍数" align="center" :show-overflow-tooltip="true"> </el-table-column>

      <el-table-column prop="create_time" label="下注时间" align="center" :show-overflow-tooltip="true"> </el-table-column>

      <el-table-column prop="status" label="状态" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <template v-if="scope.row.guess.status == 1">
            <span v-if="scope.row.guess.endTime > new Date()" style="color: #02a8a2"> 进行中 </span>
            <span v-else style="color: #999999">待开奖</span
            ><!-- 已结束 -->
          </template>
          <span v-else-if="scope.row.guess.status == 2" style="color: #999999">待开奖</span
          ><!-- 已结束 -->
          <span v-else-if="scope.row.guess.status == 3" style="color: #999999">已取消</span>
          <span v-else-if="scope.row.guess.status == 4" style="color: #999999">已开奖</span>
          <span v-else-if="scope.row.guess.status == 5" style="color: #999999">开奖后取消</span>
          <span v-else-if="scope.row.guess.status == 6" style="color: #999999">已取消</span>
        </template>
      </el-table-column>

      <el-table-column label="开奖结果" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">待开奖</span>
          <span v-else-if="scope.row.status == 2">未中奖</span>
          <span v-else-if="scope.row.status == 3">恭喜已猜中！</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="彩金" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.pay_status == 0">待核算</span>
          <span v-else-if="scope.row.pay_status == 1">
            <span style="color: #02a8a2" v-if="scope.row.profit > 0">+{{ Number(scope.row.profit / 100).toFixed(2) }}</span>
            <span v-else>{{ scope.row.profit }}</span>
          </span>
          <span v-else-if="scope.row.pay_status == 2">已退款</span>
          <span v-else-if="scope.row.pay_status == 3">已撤销奖金</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <div slot="empty" class="search_list">
        <div class="list_body">
          <div class="empty_content">
            <!-- <img src="https://test-1301875615.cos.ap-beijing.myqcloud.com/images/20211013094041773982020-12-15%2021.33.14.jpg"
                 alt="" />
            <div class="empty_text">暂无任何记录哦～</div>
            -->
            <Empty text="暂时没有数据" :imgWidth="250" :img="require('@/assets/img/empty/consume.png')"></Empty>
          </div>
        </div>
      </div>
    </el-table>

    <div class="pagination_bottom">
      <el-pagination background layout="prev, pager, next" :page-size="info.size" :total="totalCount" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="info.page">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { post } from "../../util/http";
import { mapState } from "vuex";
import moment from "moment";
import Empty from "@/components/empty/empty";
export default {
  components: {
    Empty,
  },
  data() {
    return {
      moment: moment,
      loading: false,
      formInline: {
        time: [],
      },
      tableData: [],
      info: {
        page: 1,
        size: 8,
      },
      totalCount: 0,
    };
  },
  props: {},
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    this.getListInfo();
    // console.log(this.userInfo);
  },
  mounted() {
    this.$nextTick(() => {
      let keyNode = document.querySelector(".el-date-editor");
      console.log(keyNode);
      if (!keyNode) return;
      /*
      let iNode = document.createElement("i");
      iNode.setAttribute("class", "el-icon-date"); // el-icon-bottom
      keyNode.appendChild(iNode);

      iNode.style.position = "absolute";
      iNode.style.top = "13px";
      iNode.style.right = "13px";
      */
    });
  },
  filters: {
    formatData: (value) => {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      let m = date.getMinutes();
      let s = date.getSeconds();
      h = h < 10 ? "0" + h : h;
      m = m < 10 ? "0" + m : m;
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + "" + h + ":" + m + ":" + s;
    },
  },
  methods: {
    changeDate() {
      this.getListInfo();
    },
    handleSizeChange(val) {
      this.$set(this.info, "size", val);
      // console.log(`每页 ${val} 条`);
      this.selectList();
    },
    handleCurrentChange(val) {
      this.$set(this.info, "page", val);
      //console.log(`当前页: ${val}`);
      this.getListInfo();
    },
    getListInfo() {
      this.loading = true;
      let data = {
        page: this.info.page,
        size: this.info.size,
        uid: this.userInfo.id,
        status: 0,
      };
      if (this.formInline.time && this.formInline.time.length) {
        //data.t_end = String(new Date(this.formInline.time[1]).getTime() / 1000) || "";
        //data.t_start = String(new Date(this.formInline.time[0]).getTime() / 1000) || "";
        data.t_end = this.formInline.time[1] + " 23:59:59" || "";
        data.t_start = this.formInline.time[0] + " 00:00:00" || "";
      }
      // console.log(data)
      post({
        url: "/api/guess/getGuessOrderList",
        data,
      })
        .then(({ data: { data } }) => {
          const list = data.guessOrder || [];
          list.forEach((v) => {
            let { guess = {}, guess_item = "" } = v;
            if (guess.content) {
              guess.contentArr = guess.content?.split("|");
            } else {
              guess.contentArr = ["", ""];
            }
            if (guess.end_time) {
              guess.endTime = new Date(guess.end_time);
            }
            if (guess.odds) {
              let oddsList = [];
              try {
                let jsonList = JSON.parse(guess.odds);
                jsonList.forEach((item) => {
                  oddsList.push(Number(item / 100));
                });
                guess.oddsList = oddsList;
              } catch (e) {
                guess.oddsList = [0, 0];
              }
              if (guess_item && guess_item > 0) {
                let t = guess_item == 1 ? "A: " : guess_item == 2 ? "B: " : "";
                v.oddsFormat = t + guess.oddsList[guess_item - 1];
                v.guessItemStr = t + guess.contentArr[guess_item - 1];
              }
            }
          });
          console.log("list: ", list);
          this.tableData = list;
          this.totalCount = data.total || 0;
          setTimeout(() => {
            this.loading = false;
          }, 20);
          // this.$emit('backCount', data.count)
        })
        .catch((err) => {
          setTimeout(() => {
            this.loading = false;
          }, 20);
        });
    },
    // 设置表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // return 'background-color: #c7e7e2;color:#526e6e;font-size: 14px;font-weight:600; height: 36px;padding: 0px'
      return `
				background-color:#02A8A2;
				color:#ffffff;
				font-size: 14px;
				font-weight:600; 
				height: 36px;
				padding: 0px";
				border : 0px;
			 `;
    },
    tableHeaderRow() {
      //return 'height: 36px'
      return `
				height:56px;
				letter-spacing:1px;
				border-radius : 20px;
			`;
    },
    // handleSizeChange(val) {
    // 	console.log(`每页 ${val} 条`);
    // },
    // handleCurrentChange(val) {
    // 	console.log(`当前页: ${val}`);
    // }
  },
};
</script>

<style lang="stylus" scoped>
.record-com{
	/deep/{
		.el-range__close-icon{
			right : 40px !important;
			z-index : 1000;
		}
		.el-range-editor--medium .el-range__close-icon, .el-range-editor--medium .el-range__icon{
			position : absolute;
			right : 10px;
			justify-content: center;
			display: flex;
			align-items: center;
		}
	 .el-icon-date:before {
			content: "";
			background: url(../../assets/img/guessing-management/date.png) no-repeat;
			background-size: 100% auto;
			display: block;
			width: 18px;
			height: 18px;
		}
		.el-table{
			// border : 0px;
			border-top-left-radius: 13px;
			border-top-right-radius: 13px;
		}
		.el-pagination{
			padding : 30px 0px;
		}
		.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
			color : #02A8A2;
			background : #ffffff;
			border : 1px solid #DBDBDB;
		}
		.el-pagination.is-background .el-pager li:not(.disabled).active{
			background : #02A8A2;
			color : #ffffff;
			border-color : #02A8A2;
		}
	}
	.handler-panel{
		img {
			height : 17px;
			margin : 0px 5px;
		}
	}
	.pagination_bottom {
			padding: 10px;
			display: flex;
			justify-content: center;
	}
}
</style>
